import '../App.css';
import { Carousel, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaMapMarkedAlt, FaPhoneAlt, FaTelegramPlane } from 'react-icons/fa';
import React from 'react';
import DonationSupport from '../componenti/DonationSupport';
import dahdon from './dahdon.mp4';
import post from './200.jpg';

const homeGalleryContext = require.context('../images', false, /\.(jpe?g)$/);
const homeGalleryImages = homeGalleryContext
  .keys()
  .filter((path) => !['./1.jpg', './2.jpg', './3.jpg', './5.jpg', './georgiy.jpeg'].includes(path))
  .sort((a, b) => a.localeCompare(b, 'ru', { numeric: true, sensitivity: 'base' }))
  .map((path) => homeGalleryContext(path));

const tileLayout = [
  'home-photo-tile-large',
  '',
  '',
  'home-photo-tile-tall',
  'home-photo-tile-wide',
  '',
];

function getRandomPhotos() {
  return [...homeGalleryImages]
    .sort(() => Math.random() - 0.5)
    .slice(0, 12);
}

function HomePhotoMosaic({ images }) {
  return (
    <div className="home-photo-mosaic">
      {images.map((image, index) => (
        <Link
          to="/photo"
          className={['home-photo-tile', tileLayout[index] || ''].filter(Boolean).join(' ')}
          key={`${image}-${index}`}
        >
          <img src={image} alt={`Фотография приходской жизни ${index + 1}`} loading="lazy" />
        </Link>
      ))}
    </div>
  );
}

function MainPage() {
  const randomPhotos = React.useMemo(() => getRandomPhotos(), []);
  const firstPhotoSet = randomPhotos.slice(0, 6);
  const lastPhotoSet = randomPhotos.slice(6, 12);

  return (
    <main className="page-main">
      <Container className="main-page pb-5">
        <section className="hero-section">
          <Row className="g-4 align-items-stretch">
            <Col lg={6}>
              <div className="hero-left-stack">
                <div className="hero-text-card surface-card">
                  <p className="section-overline">Добро пожаловать</p>
                  <h2 className="hero-title">Свято-Георгиевский храм в станице Даховской</h2>
                  <p className="hero-lead">
                    Здесь собраны актуальные сведения о приходе: расписание богослужений,
                    новости о строительстве нового храма, фотогалерея и контакты.
                  </p>

                  <div className="hero-donation-inline">
                    <DonationSupport compact />
                  </div>

                  <div className="hero-actions">
                    <Link to="/donate" className="button-primary">Поддержать строительство</Link>
                    <a
                      href="https://yandex.ru/maps/11004/republic-of-adygea/house/klubnaya_ulitsa_16a/YEkYdAdhSEUHQFpufX5ycHtiZw==/?ll=40.201100%2C44.231714&z=16.87"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="button-secondary"
                    >
                      Маршрут до храма
                    </a>
                  </div>

                  <div className="hero-inline-info">
                    <span><FaPhoneAlt /> +7 (918) 424-93-95</span>
                    <span><FaMapMarkedAlt /> ул. Клубная, 16А</span>
                  </div>
                </div>

                <div className="surface-card announcement-card hero-announcement d-none d-lg-flex">
                  <div>
                    <h3>Новости прихода</h3>
                    <p>
                      Началось строительство нового храма. Следить за ходом работ можно во вкладке
                      «Строительство нового храма» и в Telegram-канале прихода.
                    </p>
                  </div>
                  <a href="https://t.me/dahovskayaGeorgiy" target="_blank" rel="noopener noreferrer" className="telegram-button">
                    <FaTelegramPlane /> Telegram-канал
                  </a>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="hero-media-card hero-video-card surface-card">
                <div className="hero-video-wrap hero-video-feature">
                  <video poster={post} controls preload="metadata">
                    <source src={dahdon} type="video/mp4" />
                  </video>
                </div>
              </div>
            </Col>
          </Row>
        </section>

        <section className="section-block d-lg-none">
          <div className="surface-card announcement-card">
            <div>
              <h3>Новости прихода</h3>
              <p>
                Началось строительство нового храма. Следить за ходом работ можно во вкладке
                «Строительство нового храма» и в Telegram-канале прихода.
              </p>
            </div>
            <a href="https://t.me/dahovskayaGeorgiy" target="_blank" rel="noopener noreferrer" className="telegram-button">
              <FaTelegramPlane /> Telegram-канал
            </a>
          </div>
        </section>

        <section className="section-block">
          <div className="surface-card home-photo-card">
            <Carousel interval={5000} className="home-photo-carousel">
              <Carousel.Item>
                <img className="d-block w-100" src={require('../images/2.jpg')} alt="Храм. Общий вид" />
              </Carousel.Item>
              <Carousel.Item>
                <img className="d-block w-100" src={require('../images/3.jpg')} alt="Приходская жизнь" />
              </Carousel.Item>
              <Carousel.Item>
                <img className="d-block w-100" src={require('../images/1.jpg')} alt="Богослужение в храме" />
              </Carousel.Item>
              <Carousel.Item>
                <img className="d-block w-100" src={require('../images/5.jpg')} alt="Территория храма" />
              </Carousel.Item>
            </Carousel>
          </div>
        </section>

        <section className="section-block">
          <div className="home-gallery-head">
            <h3 className="section-title">Фотографии приходской жизни</h3>
            <Link to="/photo" className="text-link home-gallery-link">Смотреть все фотографии</Link>
          </div>

          <HomePhotoMosaic images={firstPhotoSet} />
        </section>

        <section className="section-block">
          <h3 className="section-title">Важные разделы</h3>
          <div className="feature-grid">
            <Link to="/building" className="feature-card">
              <h4>Строительство</h4>
              <p>Актуальные видеоотчёты о работах по новому храму.</p>
              <span>Открыть <FaArrowRight /></span>
            </Link>
            <Link to="/photo" className="feature-card">
              <h4>Фотогалерея</h4>
              <p>Фотографии приходской жизни и праздников.</p>
              <span>Открыть <FaArrowRight /></span>
            </Link>
            <Link to="/donate" className="feature-card">
              <h4>Пожертвования</h4>
              <p>Реквизиты и информация о поддержке строительства.</p>
              <span>Открыть <FaArrowRight /></span>
            </Link>
            <Link to="/khram" className="feature-card">
              <h4>О святом Георгии</h4>
              <p>Краткое житие великомученика Георгия Победоносца.</p>
              <span>Открыть <FaArrowRight /></span>
            </Link>
          </div>
        </section>

        <section className="section-block">
          <Row className="g-4 align-items-stretch">
            <Col lg={5}>
              <div className="surface-card schedule-card h-100">
                <h3>Расписание богослужений</h3>
                <div className="schedule-grid">
                  <div>
                    <h4>Суббота</h4>
                    <p>14:00 Панихида</p>
                    <p>16:00 Вечерняя</p>
                  </div>
                  <div>
                    <h4>Воскресенье</h4>
                    <p>7:30 Исповедь</p>
                    <p>8:00 Литургия</p>
                  </div>
                </div>
                <p className="schedule-note">Уточнить, будет ли служба, можно по телефону: +7 (918) 424-93-95.</p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="surface-card map-card h-100">
                <h3>Как добраться</h3>
                <p>Адрес: Майкопский р-н, ст. Даховская, ул. Клубная, 16А</p>
                <iframe
                  title="Карта проезда к храму"
                  loading="lazy"
                  src="https://yandex.ru/map-widget/v1/?um=constructor%3A718be2faf759369d95d6abe2d739bea59b07dbcf81449ca3779b88556d545691&amp;source=constructor"
                  frameBorder="0"
                ></iframe>
              </div>
            </Col>
          </Row>
        </section>

        <section className="section-block">
          <h3 className="section-title">Кратко о приходе</h3>
          <Row className="g-4">
            <Col md={6}>
              <article className="surface-card article-card h-100">
                <h4>История храма Георгия Победоносца</h4>
                <p>
                  Станица Даховская основана в 1862 году. Георгиевский храм был построен в 1864 году,
                  затем пережил закрытие и утрату, а в наши дни приход возрожден по благословению владыки.
                  Сейчас богослужения снова совершаются в станице, и община продолжает развитие.
                </p>
              </article>
            </Col>
            <Col md={6}>
              <article className="surface-card article-card h-100">
                <h4>Георгий Победоносец</h4>
                <p>
                  Святой великомученик Георгий особенно почитается в православной традиции как пример
                  мужества, верности Христу и духовной стойкости. На отдельной странице размещено более
                  подробное житие святого.
                </p>
                <Link to="/khram" className="text-link">Перейти к подробному тексту</Link>
              </article>
            </Col>
          </Row>
        </section>

        <section className="section-block">
          <div className="home-gallery-head">
            <h3 className="section-title">Еще фотографии</h3>
            <Link to="/photo" className="text-link home-gallery-link">Перейти в фотогалерею</Link>
          </div>

          <HomePhotoMosaic images={lastPhotoSet} />
        </section>
      </Container>
    </main>
  );
}

export default MainPage;
